module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "sub-section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Front cover")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William Maitland of Lethington, Mary’s Secretary of State, whose doubtful loyalty caused him to be dubbed the ‘chameleon’ by George Buchanan. (Oil on panel / Lennoxlove House Limited / scran.ac.uk / 000-000-027-976-R)")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Picture section")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir John Maitland of Thirlestane")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lethington House (now Lennoxlove)")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Queen of Scots")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary of Guise")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lord James Stewart (later Earl of Moray)")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David Riccio")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palace of Holyrood House")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Stuart, Lord Darnley")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Craigmillar Castle")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Douglas, 4th Earl of Morton")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lochleven Castle")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew Stuart, 4th Earl of Lennox")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stirling Castle")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Hepburn,4th Earl of Bothwell")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Dudley, Earl of Leicester")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Howard, 4th Duke of Norfolk")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elizabeth I")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab101"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Cecil, Lord Burghley")])]), _vm._v(" "), _c('td', {
    staticClass: "tab102"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Plates#plates18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d48e32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_ListofIllustration.vue
// module id = 69
// module chunks = 0